export default {
  methods: {
    is_empty(_var) {
      if (_var == null) {
        // typeof null -> object : for hack a bug of ECMAScript
        return true
      }
      switch (typeof _var) {
        case 'object':
          if (Array.isArray(_var)) {
            // When object is array:
            return _var.length === 0
          } else {
            // When object is not array:
            if (
              Object.keys(_var).length > 0 ||
              Object.getOwnPropertySymbols(_var).length > 0
            ) {
              return false
            } else if (_var.valueOf().length !== undefined) {
              return _var.valueOf().length === 0
            } else if (typeof _var.valueOf() !== 'object') {
              return this.is_empty(_var.valueOf())
            } else {
              return true
            }
          }
        case 'string':
          return _var === ''
        case 'number':
          return _var == 0
        case 'boolean':
          return !_var
        case 'undefined':
        case 'null':
          return true
        case 'symbol':
          break
        // Since ECMAScript6
        case 'function':
          break
        default:
          return false
      }
    },
    isset(_var) {
      if (_var === null || _var === undefined) {
        return false
      } else {
        return true
      }
    },
    in_array(_var, arr) {
      if (arr.indexOf(_var) >= 0) {
        return true
      } else {
        return false
      }
    },
    trimText(text, limit) {
      return text.length > limit ? text.slice(0, limit) + '…' : text
    },
    maskText(text, isShow) {
      return isShow ? text : '*****'
    },
    exportCSV(headers, items, outputName) {
      const head = []
      const body = []
      for (let i = 0; i < items.length; i++) {
        body.push([])
        // ヘッダーに対応する順で配列に入れていく
        headers.forEach((header) => {
          if (header.value != 'action') {
            if (i === 0) head.push(header.text)
            body[i].push(items[i][header.value])
          }
        })
      }
      const records = [head, ...body]
      const data = records.map((record) => record.join(',')).join('\r\n')
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom, data], { type: 'text/csv' })
      const url = (window.URL || window.webkitURL).createObjectURL(blob)
      const link = document.createElement('a')
      link.download = outputName ? `${outputName}.csv` : 'result.csv'
      link.href = url
      link.click()
    }
  }
}
